import { useContext } from "react";
import { breakpointContext } from "../BraidProvider/BreakpointContext.mjs";
import { resolveResponsiveObject } from "./resolveResponsiveObject.mjs";
const useResponsiveValue = () => {
  const breakpointName = useContext(breakpointContext);
  return function responsiveValue(value) {
    return breakpointName ? resolveResponsiveObject(breakpointName, value) : null;
  };
};
export {
  useResponsiveValue
};
